import { render, staticRenderFns } from "./SdiOrganization.vue?vue&type=template&id=03d9686e&scoped=true"
import script from "./SdiOrganization.vue?vue&type=script&lang=js"
export * from "./SdiOrganization.vue?vue&type=script&lang=js"
import style0 from "./SdiOrganization.vue?vue&type=style&index=0&id=03d9686e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d9686e",
  null
  
)

export default component.exports